import { apiFetchCouponList, apiFetchMutiCouponList } from '@/api/imee'

export const couponMixin = {
  data() {
    return {
      // scene=activity不显示优惠券入口
      scene: this.$route.query.scene || null,

      // popup/tab
      showCoupon: false,
      couponTabActive: 0,
      couponTabTit: [
        {
          id: 0,
          tit0: this.$t('lang.BaseCommon.k068'),
        },
        {
          id: 1,
          tit1: this.$t('lang.BaseCommon.k061'),
        },
      ],

      // 优惠券
      validCouponList: [],
      validCouponListSort: [],
      expiredCouponList: [],
      maxCoupon: {},

      // 支付结果
      showResultDia: false,
      payResultText: '',
    }
  },

  methods: {
    // 获取shopType
    getShopType() {
      if (this.$route.query.shopType) {
        return this.$route.query.shopType
      }
      // 路由参数无
      else {
        return this.scene == 'activity' ? 7 : null
      }
    },
    // 客户端支付回调
    onNewIntent(url) {
      if (url) {
        const data = JSON.parse(url)
        if (data.status == 'PENDING') {
          this.payResultText = this.$t('lang.BaseCommon.k090')
          this.showResultDia = true
        }
        if (data.status == 'FAILED') {
          this.payResultText = this.$t('lang.BaseCommon.k089')
          this.showResultDia = true
        }
        if (data.status == 'CLOSED') {
          this.payResultText = 'Closed'
          this.showResultDia = true
        }
      }
    },

    // pay 优惠劵 相关的函数
    // 获取优惠劵 优惠券状态 0-待使用 1-使用锁定 2-已使用 3-已过期
    fetchCouponList(couponState) {
      this.maxCoupon = null
      apiFetchCouponList({
        state: couponState,
      }).then((res) => {
        if (res) {
          if (couponState == 0) {
            this.validCouponList = res
          }
          if (couponState == 3) {
            this.expiredCouponList = res
          }
        }
      })
    },
    // 获取优惠券-多参数
    fetchMutiCouponList(val) {
      apiFetchMutiCouponList({}).then((resData) => {
        if (resData) {
          // 有效的
          this.validCouponList = resData.validCouponRecords || []
          // 过期的
          this.expiredCouponList = resData.invalidCouponRecords || []
        }
      })
    },
    // 找最优的优惠券
    fetchMaxCoupon(item, couponList) {
      let list = null
      if (couponList) {
        list = couponList
      }
      //
      else {
        list = this.validCouponList
      }

      if (item) {
        const arr = list.filter((option) => {
          return option.minUseAmount <= item.amount
        })
        // 从大到小
        this.validCouponListSort = arr.sort((a, b) => b.amount - a.amount)
        this.maxCoupon = this.validCouponListSort[0] || null
      }
    },
    // 打开优惠券列表
    openCouponPop() {
      this.fetchCouponList(0)
      this.showCoupon = true
    },
    // 选中优惠卷
    confirmChooseCouponId(option) {
      if (Object.keys(option).length > 0) {
        this.maxCoupon = option
      } else {
        this.maxCoupon = this.validCouponListSort[0] || null
      }
      this.closeCouponPop(false)
    },
    // 关闭优惠劵
    closeCouponPop(val) {
      this.showCoupon = val
    },
  },

  created() {
    if (this.scene != 'activity') {
      this.fetchMutiCouponList()
    }
  },

  mounted() {
    window.onNewIntent = this.onNewIntent
  },
}
